import * as colors from './colors';
import * as spacing from './spacing';
import * as typography from './typography';

export const theme = {
  colors: { ...colors, list: colors.colors },
  typography,
  spacing,
};
